<template>
  <div class="main">
    <Header 
      :show="true"
      title="原料区道闸"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-cell
        :value="listQuery.date.range"
        is-link
        @click="listQuery.date.show = true"
      >
        <template #title>
          <span style="font-size: 2vh;">时间区间</span>
        </template>
      </van-cell>
      <van-calendar 
        v-model="listQuery.date.show" 
        type="range" 
        :max-range="366" 
        :min-date="listQuery.date.min" 
        :max-date="listQuery.date.max"
        :default-date="listQuery.date.default"
        color="#ee0a24"
        :style="{ 'padding-bottom': '30px' }" 
        @confirm="onConfirmDateChoose" 
      />
      <van-cell 
        :value="listQuery.type.name"
        is-link
        @click="listQuery.type.show = true"
      >
        <template #title>
          <span style="font-size: 2vh;">货车类型</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.type.show"
        :actions="listQuery.type.actions"
        cancel-text="取消"
        description="请选择待查询的货车类型"
        @select="onSelectTypeChoose"
      />
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          @click="handleClickQuery"
        >
          查询
        </van-button>
      </div>
      
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{row}">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="司机">
                <span>{{ row.driver }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item label="货车类型">
                <span>{{ row.truckType }}</span>
              </el-form-item>
              <el-form-item label="入场时间">
                <span>{{ row.accessTime }}</span>
              </el-form-item>
              <el-form-item label="离场时间">
                <span>{{ row.exitTime }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag
                  v-if="row.status === '访问中'"
                  type="success"
                >
                  访问中
                </el-tag>
                <el-tag
                  v-else
                  type="info"
                >
                  已离开
                </el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="60"
        >
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNumber"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="司机"
          prop="driver"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.driver }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          align="center"
          min-width="80"
        >
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status === '访问中'"
              type="success"
            >
              访问中
            </el-tag>
            <el-tag
              v-else
              type="info"
            >
              已离开
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination 
        v-show="table.total>0" 
        :total="table.total" 
        background 
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getTruckHistoryList } from '@/api/car.js'

  export default {
    name: "ServiceHistoryFace",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const dayTimeStamp = (new Date(EDate)).getTime()
      const beforeTimeStamp = dayTimeStamp - 7*24*3600*1000
      const SDate = parseTime(beforeTimeStamp, '{y}/{m}/{d}')
      return {
      listQuery: {
          limit: 10,
          page: 1,
          date: {
            show: false,
            min: new Date(2020, 1, 1),
            max: new Date(2030, 12, 31),
            range: SDate + ' - ' + EDate,
            start: beforeTimeStamp,
            end: dayTimeStamp,
            default: [new Date(SDate), new Date(EDate)]
          },
          plateNumber: '',
          area: {
            show: false,
            actions: [
              { name: '办公区', subname: '' },
              { name: '原料区' }
            ],
            name: '办公区'
          },
          type: {
            show: false,
            actions: [
              { name: '骨料货车', subname: '' },
              { name: '罐装货车' },
              { name: '商砼货车' }
            ],
            name: '骨料货车'
          }
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.accessTime
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {

      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          startDate: this.listQuery.date.start,
          endDate: this.listQuery.date.end,
          truckType: this.listQuery.type.name,
          plateNumber: this.listQuery.plateNumber
        }
        getTruckHistoryList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                driver: items[i].driver,
                plateNumber: items[i].plateNumber,
                truckType: items[i].truckType,
                accessTime: parseTime(items[i].accessTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                exitTime: parseTime(items[i].exitTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                status: items[i].exitTime === '' ? '访问中' : '已离开'
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      formatDate(date) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        return `${year}/${(month + 1) >9 ? (month + 1) : '0'+(month + 1)}/${day > 9 ? day : '0'+day}`
      },
      onConfirmDateChoose(date) {
        const [start, end] = date
        this.listQuery.date.show = false
        this.listQuery.date.range = `${this.formatDate(start)} - ${this.formatDate(end)}`
        this.listQuery.date.start = (new Date(start)).getTime()
        this.listQuery.date.end = (new Date(end)).getTime()
      },
      onSelectAreaChoose(item) {
        this.listQuery.area.show = false
        this.listQuery.area.name = item.name
      },
      onSelectTypeChoose(item) {
        this.listQuery.type.show = false
        this.listQuery.type.name = item.name
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
